import {
  faAlarmClock,
  faAnglesUpDown,
  faArchive,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowUp,
  faArrowUpRightFromSquare,
  faArrowsAlt,
  faArrowTurnRight,
  faArrowTurnDownLeft,
  faArrowTurnDownRight,
  faArrowUpFromLine,
  faAsterisk,
  faAt,
  faBan,
  faBold,
  faBolt,
  faBook,
  faBorderAll,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDashed,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faClone,
  faCommentsAlt,
  faCopy,
  faCreditCard,
  faCrown,
  faDatabase,
  faDotCircle,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faExchange,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faFaceAwesome,
  faFileAlt,
  faFileCheck,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFiles,
  faFileSignature,
  faFileUpload,
  faFileXmark,
  faFileWord,
  faFolder,
  faFolderOpen,
  faFolderUpload,
  faFontCase,
  faGavel,
  faGear,
  faHeading,
  faHighlighterLine,
  faHighlighter,
  faHourglassStart,
  faHouse,
  faICursor,
  faIdBadge,
  faIdCard,
  faIndent,
  faItalic,
  faKey,
  faLevelUp,
  faLink,
  faList,
  faListAlt,
  faListOl,
  faLockAlt,
  faMagnifyingGlass,
  faMemo,
  faMinus,
  faOutdent,
  faPaperclip,
  faPen,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRectangleHistory,
  faRedo,
  faRemoveFormat,
  faSave,
  faSdCard,
  faSearch,
  faShare,
  faShieldCheck,
  faSidebarFlip,
  faSignature,
  faSlidersH,
  faSort,
  faSpinnerThird,
  faSquare,
  faStrikethrough,
  faTableLayout,
  faTasks,
  faTextSize,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTrashAlt,
  faTrashCan,
  faUnderline,
  faUser,
  faUserFriends,
  faUserLock,
  faUserPen,
  faUserShield,
  faUsers,
  faVault,
  faXmark,
} from '@awesome.me/kit-da13514c94/icons/classic/regular'

export const regularLibrary = [
  faAlarmClock,
  faAnglesUpDown,
  faArchive,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowUpRightFromSquare,
  faArrowUp,
  faArrowsAlt,
  faArrowTurnRight,
  faArrowTurnDownLeft,
  faArrowTurnDownRight,
  faArrowUpFromLine,
  faAsterisk,
  faAt,
  faBan,
  faBold,
  faBolt,
  faBook,
  faBorderAll,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDashed,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faClone,
  faCommentsAlt,
  faCopy,
  faCreditCard,
  faCrown,
  faDatabase,
  faDotCircle,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faExchange,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faFaceAwesome,
  faFileAlt,
  faFileCheck,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFiles,
  faFileSignature,
  faFileUpload,
  faFileXmark,
  faFileWord,
  faFolder,
  faFolderOpen,
  faFolderUpload,
  faFontCase,
  faGavel,
  faGear,
  faHeading,
  faHighlighterLine,
  faHighlighter,
  faHourglassStart,
  faHouse,
  faICursor,
  faIdBadge,
  faIdCard,
  faIndent,
  faItalic,
  faKey,
  faLevelUp,
  faLink,
  faList,
  faListAlt,
  faListOl,
  faLockAlt,
  faMagnifyingGlass,
  faMemo,
  faMinus,
  faOutdent,
  faPaperclip,
  faPen,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRectangleHistory,
  faRedo,
  faRemoveFormat,
  faSave,
  faSdCard,
  faSearch,
  faShare,
  faShieldCheck,
  faSidebarFlip,
  faSignature,
  faSlidersH,
  faSort,
  faSpinnerThird,
  faSquare,
  faStrikethrough,
  faTableLayout,
  faTasks,
  faTextSize,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTrashAlt,
  faTrashCan,
  faUnderline,
  faUser,
  faUserFriends,
  faUserLock,
  faUserPen,
  faUserShield,
  faUsers,
  faVault,
  faXmark,
]
